import { Link } from "react-router-dom";

/**
 * HiredLogo — (H) bracket monogram + "HIRED" wordmark with a stylised
 * horizontal-line E and D (rendered via inline SVG). Scales via `size`.
 */
export default function HiredLogo({ size = 22, tone = "ivory" }) {
  const ivory = "#F6F2E9";
  const gold  = "#D4AF37";
  const stroke = tone === "dark" ? "#0B0D10" : ivory;
  const height = size;
  const width  = size * 5.8; // approximate lockup ratio
  return (
    <span aria-label="HIRED" className="inline-flex items-center gap-3" data-testid="brand-logo">
      <svg width={height} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4 L4 28" stroke={gold} strokeWidth="2.5" />
        <path d="M4 4 L10 4" stroke={gold} strokeWidth="2.5" />
        <path d="M4 28 L10 28" stroke={gold} strokeWidth="2.5" />
        <path d="M12 8 L12 24" stroke={stroke} strokeWidth="2.5" />
        <path d="M20 8 L20 24" stroke={stroke} strokeWidth="2.5" />
        <path d="M12 16 L20 16" stroke={stroke} strokeWidth="2.5" />
        <path d="M28 4 L28 28" stroke={gold} strokeWidth="2.5" />
        <path d="M22 4 L28 4" stroke={gold} strokeWidth="2.5" />
        <path d="M22 28 L28 28" stroke={gold} strokeWidth="2.5" />
      </svg>
      <svg viewBox="0 0 220 40" height={height * 1.05} width={width} fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* H */}
        <path d="M6 4 V36" stroke={stroke} strokeWidth="4" strokeLinecap="square" />
        <path d="M28 4 V36" stroke={stroke} strokeWidth="4" strokeLinecap="square" />
        <path d="M6 20 H28" stroke={stroke} strokeWidth="4" strokeLinecap="square" />
        {/* I */}
        <path d="M44 4 V36" stroke={stroke} strokeWidth="4" strokeLinecap="square" />
        {/* R */}
        <path d="M60 4 V36" stroke={stroke} strokeWidth="4" strokeLinecap="square" />
        <path d="M60 4 H80 V18 H60" stroke={stroke} strokeWidth="4" strokeLinecap="square" />
        <path d="M72 20 L82 36" stroke={stroke} strokeWidth="4" strokeLinecap="square" />
        {/* E — three horizontal bars only (no left vertical) */}
        <path d="M96 4 H118" stroke={stroke} strokeWidth="4" strokeLinecap="square" />
        <path d="M96 20 H114" stroke={gold} strokeWidth="4" strokeLinecap="square" />
        <path d="M96 36 H118" stroke={stroke} strokeWidth="4" strokeLinecap="square" />
        {/* D (stylised horizontal-line) */}
        <path d="M132 4 H150 Q160 4 160 20 Q160 36 150 36 H132 Z" fill={stroke} />
        <path d="M138 10 H150 Q154 10 154 20 Q154 30 150 30 H138 Z" fill="#0B0D10" />
        <path d="M138 18 H154" stroke={gold} strokeWidth="4" strokeLinecap="butt" />
      </svg>
    </span>
  );
}

export function HiredMark({ size = 22, tone = "ivory" }) {
  const gold  = "#D4AF37";
  const stroke = tone === "dark" ? "#0B0D10" : "#F6F2E9";
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4 L4 28" stroke={gold} strokeWidth="2.5" />
      <path d="M4 4 L10 4" stroke={gold} strokeWidth="2.5" />
      <path d="M4 28 L10 28" stroke={gold} strokeWidth="2.5" />
      <path d="M12 8 L12 24" stroke={stroke} strokeWidth="2.5" />
      <path d="M20 8 L20 24" stroke={stroke} strokeWidth="2.5" />
      <path d="M12 16 L20 16" stroke={stroke} strokeWidth="2.5" />
      <path d="M28 4 L28 28" stroke={gold} strokeWidth="2.5" />
      <path d="M22 4 L28 4" stroke={gold} strokeWidth="2.5" />
      <path d="M22 28 L28 28" stroke={gold} strokeWidth="2.5" />
    </svg>
  );
}
